/**
 * Contact Information Constants
 * Extracted to separate file to avoid circular dependencies
 */

export const STAGE_CONTACT_NUMBER = "011-41171577";
